window.$zoho = window.$zoho || {}
$zoho.salesiq = $zoho.salesiq || {
  widgetcode: "siqf0b06c4e71e0b031e69bb78878e305efaed0872cf7970528166395701e11d5dc",
  values: {},
  ready: () => {
    $zoho.salesiq.floatwindow.minimize(() =>
      window.$zoho.salesiq.floatwindow.close()
    )
  }
}
var d = document
s = d.createElement('script')
s.type = 'text/javascript'
s.id = 'zsiqscript'
s.defer = true
s.src = 'https://salesiq.zoho.com/widget'
t = d.getElementsByTagName('script')[0]
t.parentNode.insertBefore(s, t)
